import { reduce } from 'lodash';

export const remaining = ({ cart }) => cart.remaining;

export const subsection = (
  { dashboard, inCartModels, bodyStyles },
  { subsectionId },
) =>
  dashboard.brand === 'MI'
    ? inCartModels.byId[subsectionId]
    : bodyStyles.byId[subsectionId];

export const totalCartQuantity = ({ cart }) => Number(cart.totalInCart);

export const totalSelected = ({ inCartTemplates }) =>
  Object.values(inCartTemplates.byId)
    .filter(template => template.selected)
    .reduce((sum, template) => {
      let templateSum = reduce(
        template.prioritiesToQuantitiesMap,
        function(result, value, key) {
          return result + value;
        },
        0,
      );
      return (sum += templateSum);
    }, 0);

export const selectedTemplatesMappings = ({ inCartTemplates }) => {
  const mappingsByModelId = {};
  const selectedTemplates = Object.values(inCartTemplates.byId).filter(
    template => template.selected,
  );
  const selectedModelIds = selectedTemplates.map(template => template.modelId);
  selectedModelIds.forEach(modelId => (mappingsByModelId[modelId] = []));
  selectedTemplates.forEach(template =>
    mappingsByModelId[template.modelId].push(template.id),
  );
  return mappingsByModelId;
};

export const designPackageKeys = ({ dashboard }) => {
  let optionKeys;
  if (dashboard.productType === '0') {
    optionKeys = ['paintOption'];
  } else {
    if (dashboard.brand === 'MI') {
      optionKeys = [
        'paintOption',
        'interiorOption',
        'trimOption',
        'wheelOption',
        'colorLineOption',
        'roofAndMirrorCapOption',
      ];
    } else {
      optionKeys = [
        'paintOption',
        'interiorOption',
        'trimOption',
        'wheelOption',
      ];
    }
  }
  return optionKeys;
};
